import { provide, inject, reactive } from 'vue';

/**
 * 创建模块专用的上下文系统
 * @param {string} moduleName - 模块名称 (如: 'investment_activity', 'news', 'quote')
 * @param {function} buildDefaultContext - 构建默认上下文的函数
 * @returns {object} 包含 provide 和 use 方法的上下文系统
 */
export function createModuleContext(moduleName, buildDefaultContext) {
	const CONTEXT_KEY = Symbol(`MODULE_CONTEXT_${moduleName.toUpperCase()}`);

	/**
	 * 提供模块上下文
	 * @param {object} overrides - 覆盖配置
	 * @returns {object} 响应式上下文对象
	 */
	function provideModuleContext(overrides = {}) {
		const ctx = reactive({
			...buildDefaultContext(),
			...overrides,
			// 添加模块标识，方便调试
			__module: moduleName
		});

		provide(CONTEXT_KEY, ctx);
		return ctx;
	}

	/**
	 * 使用当前模块上下文
	 * @returns {object} 响应式上下文对象
	 */
	function useModuleContext() {
		const ctx = inject(CONTEXT_KEY, null);
		if (ctx) {
			return ctx;
		}
		// 回退到默认上下文
		return reactive({
			...buildDefaultContext(),
			__module: moduleName
		});
	}

	return {
		provide: provideModuleContext,
		use: useModuleContext,
		moduleName
	};
}
